import { useState } from "react";
import { motion } from "framer-motion";
import { SendHorizontal } from "lucide-react";

export default function ChatInput({ sendMessage }) {
  const [message, setMessage] = useState("");

  const handleSend = () => {
    if (!message.trim()) return;

    sendMessage(message);
    setMessage("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="border-t border-white/10 bg-[#111827]/80 backdrop-blur-xl p-3">
      <div className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/5 p-2 shadow-lg">

        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Ask GrowX AI anything..."
          className="flex-1 bg-transparent px-3 text-[13px] text-white placeholder:text-white/40 outline-none"
        />

        <motion.button
          onClick={handleSend}
          whileHover={{ scale: 1.08 }}
          whileTap={{ scale: 0.92 }}
          disabled={!message.trim()}
          className={`flex p-2 items-center justify-center rounded-xl transition-all duration-300 ${
            message.trim()
              ? "bg-gradient-to-r from-violet-600 via-fuchsia-600 to-pink-600 text-white shadow-[0_10px_30px_rgba(168,85,247,0.45)]"
              : "bg-white/10 text-white/40 cursor-not-allowed"
          }`}
        >
          <SendHorizontal size={12} />
        </motion.button>

      </div>
    </div>
  );
}